import React, { useState } from "react";
import { Divider, InfoTimeCardAdv } from "../../../../../components";

const InfoTimeCardAdvList = () => {
  const [isShowAlert, setIsShowAlert] = useState(false);
  const variants = [
    "text",
    "contained",
    "outlined",
    "titleContained",
    "valueContained",
  ];
  const variantsTwo = ["text", "contained", "outlined"];
  const colors = ["primary", "warning", "success", "danger", "info", "black"];
  const sizes = ["xs", "xs-sm", "sm", "md", "lg", "xl"];
  const oneLines = [true, false];
  const aligns = ["left", "center", "right"];
  return (
    <div className="w-full flex flex-col gap-10 py-5">
      {variants.map((variant, variantIndex) => (
        <div key={`variant-${variantIndex}`} className="mb-8">
          <h4 className="text-md font-medium mb-2">Variant: {variant}</h4>
          <div className="grid grid-cols-6 gap-4">
            {colors.map((color, colorIndex) => (
              <div key={`${variant}-${color}-${colorIndex}`}>
                <InfoTimeCardAdv
                  title="Amount Used"
                  value="12768.00"
                  prefix="$"
                  suffix="USD"
                  variant={variant}
                  color={color}
                />
              </div>
            ))}
          </div>
        </div>
      ))}

      {/* //////////////////////////////////////////
        //////////////////////////////////////////
        ////////////////////////////////////////// */}

      {/* InfoTimeCardAdv Sizes */}
      <div className="mt-5">
        <h3 className="text-lg font-semibold mb-3">InfoTimeCardAdv Sizes</h3>
        <div className="grid grid-cols-6 gap-4">
          {sizes.map((size, index) => (
            <div>
              <InfoTimeCardAdv
                title="Amount Used"
                value="12768.00"
                prefix="$"
                suffix="USD"
                size={size}
              />
            </div>
          ))}
        </div>
      </div>

      {/* InfoTimeCardAdv Aligns */}
      <div className="mt-5">
        <h3 className="text-lg font-semibold mb-3">InfoTimeCardAdv Aligns</h3>
        <div className="grid grid-cols-3 gap-4">
          {aligns.map((align, index) => (
            <InfoTimeCardAdv
              title="Amount Used"
              value="12768.00"
              prefix="$"
              suffix="USD"
              align={align}
            />
          ))}
        </div>
      </div>
      <div className="mt-5">
        <h3 className="text-lg font-semibold mb-3">InfoTimeCardAdv Aligns</h3>
        <div className="grid grid-cols-6 gap-4">
          {oneLines.map((oneLine, index) => (
            <>
              <InfoTimeCardAdv
                title="Amount Used"
                value="12768.00"
                prefix="$"
                suffix="USD"
                oneLine={oneLine}
              />
            </>
          ))}
        </div>
      </div>

      <div className="flex gap-2">
        <div className="w-[800px]">
          <InfoTimeCardAdv
            title="Amount Used"
            value="12768.00"
            prefix="$"
            suffix="USD"
          />
        </div>
        <Divider orientation="vertical" />
        <div className="flex-1">
          <InfoTimeCardAdv
            title="Amount Used"
            value="12768.00"
            prefix="$"
            suffix="USD"
          />
        </div>
        <Divider orientation="vertical" />
        <div className="flex-1">
          <InfoTimeCardAdv
            title="Amount Used"
            value="12768.00"
            prefix="$"
            suffix="USD"
          />
        </div>
        <Divider orientation="vertical" />
        <div className="flex-1">
          <InfoTimeCardAdv
            title="Amount Used"
            value="12768.00"
            prefix="$"
            suffix="USD"
          />
        </div>
        <Divider orientation="vertical" />
        <div className="flex-1">
          <InfoTimeCardAdv
            title="Amount Used"
            value="12768.00"
            prefix="$"
            suffix="USD"
          />
        </div>
      </div>

      <div>
        <div className="mt-5">
          <h3 className="text-lg font-semibold mb-3">
            InfoTimeCardAdv Variants with Colors
          </h3>
          {variantsTwo.map((variant, variantIndex) => (
            <div key={`variant-${variantIndex}`} className="mb-8">
              <h4 className="text-md font-medium mb-2">Variant: {variant}</h4>
              <div className="flex flex-wrap justify-between gap-4">
                {colors.map((color, colorIndex) => (
                  <div key={`${variant}-${color}-${colorIndex}`}>
                    <InfoTimeCardAdv
                      type="type2"
                      value="12768.00"
                      prefix="$"
                      suffix="USD"
                      variant={variant}
                      //variant={"text"}
                      color={color}
                    />
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default InfoTimeCardAdvList;
